    let currentLat = 48.8566;
    let currentLng = 2.3522;

    const planets = [
      { name: "Saturne", symbol: "♄" },
      { name: "Jupiter", symbol: "♃" },
      { name: "Mars", symbol: "♂" },
      { name: "Soleil", symbol: "☉" },
      { name: "Vénus", symbol: "♀" },
      { name: "Mercure", symbol: "☿" },
      { name: "Lune", symbol: "☾" }
    ];
    const dayRuling = {
      0: "Soleil",    
      1: "Lune",      
      2: "Mars",      
      3: "Mercure",   
      4: "Jupiter",   
      5: "Vénus",     
      6: "Saturne"   
    };


    function formatTime(date) {
      return date.toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' });
    }

    function ordinalHour(num) {
      return num === 1 ? num + "ère heure" : num + "ème heure";
    }

    function getNextDate(dateStr) {
      const date = new Date(dateStr);
      date.setDate(date.getDate() + 1);
      return date.toISOString().split("T")[0];
    }

    function showSkeleton(container, count) {
      container.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const skeletonCard = document.createElement('div');
        skeletonCard.className = 'hour-card skeleton';
        skeletonCard.innerHTML = `
          <div class="hour-symbol"></div>
          <div class="hour-info">
            <p class="hour-name" style="background: #ccc; width: 80%; height: 1em; margin-bottom: 0.5em;"></p>
            <p class="hour-slot" style="background: #ccc; width: 60%; height: 1em;"></p>
          </div>
        `;
        container.appendChild(skeletonCard);
      }
    }
    async function fetchSunData(dateStr) {
      const url = `https://api.sunrise-sunset.org/json?lat=${currentLat}&lng=${currentLng}&date=${dateStr}&formatted=0`;
      const response = await fetch(url);
      return response.json();
    }
    function animateTransition(container, createCardsCallback) {
      const cards = Array.from(container.children);
      cards.reverse().forEach((card, index) => {
        card.style.animationDelay = `${index * 0.1}s`;
        card.classList.add('fade-out-up');
      });
      const totalDelay = (cards.length ? ((cards.length - 1) * 0.1 + 0.5) : 0);
      setTimeout(() => {
        container.innerHTML = '';
        const newCards = createCardsCallback();
        newCards.forEach((card, index) => {
          card.style.animationDelay = `${index * 0.1}s`;
          card.classList.add('fade-in-down');
          container.appendChild(card);
        });
      }, totalDelay * 1000);
    }
    async function updatePlanetaryHours(dateStr) {
      try {
          showSkeleton(document.getElementById('day-hours'), 12);
          showSkeleton(document.getElementById('night-hours'), 12);
  
          const [sunData, nextSunData] = await Promise.all([
              fetchSunData(dateStr),
              fetchSunData(getNextDate(dateStr))
          ]);
  
          // Fonction pour convertir UTC vers heure locale (Paris)
          function toLocalTime(utcDateStr) {
              const utcDate = new Date(utcDateStr);
              return new Date(utcDate.getTime() + new Date().getTimezoneOffset() * 60000 * -1); 
          }
  
          const sunrise = new Date(sunData.results.sunrise); // UTC
          const sunset = new Date(sunData.results.sunset); // UTC
          const nextSunrise = new Date(nextSunData.results.sunrise); // UTC
  
          // Convertir en heure locale (Paris)
          const sunriseLocal = toLocalTime(sunData.results.sunrise);
          const sunsetLocal = toLocalTime(sunData.results.sunset);
          const nextSunriseLocal = toLocalTime(nextSunData.results.sunrise);
  
          const dayDuration = sunset - sunrise;
          const dayHourDuration = dayDuration / 12;
          const nightDuration = nextSunrise - sunset;
          const nightHourDuration = nightDuration / 12;
  
          const selectedDate = new Date(dateStr);
          const rulingPlanetName = dayRuling[selectedDate.getDay()];
          const rulingIndex = planets.findIndex(p => p.name === rulingPlanetName);
  
          const dayContainer = document.getElementById('day-hours');
          const nightContainer = document.getElementById('night-hours');
          const now = new Date();
          const todayStr = new Date().toISOString().split("T")[0];
          const isToday = dateStr === todayStr;
  
          // Fonction pour générer les créneaux avec UTC et heure locale
          function createHourCards(startTimeUTC, duration, startIndex) {
              const cards = [];
              for (let i = 0; i < 12; i++) {
                  const startTimeUTCInstance = new Date(startTimeUTC.getTime() + i * duration);
                  const endTimeUTCInstance = new Date(startTimeUTC.getTime() + (i + 1) * duration);
  
                  // Conversion en heure locale
                  const startTimeLocal = toLocalTime(startTimeUTCInstance);
                  const endTimeLocal = toLocalTime(endTimeUTCInstance);
  
                  const planet = planets[(rulingIndex + startIndex + i) % 7];
                  const isActive = isToday && now >= startTimeLocal && now < endTimeLocal;
  
                  const card = document.createElement('div');
                  card.className = 'hour-card';
                  card.innerHTML = `
                      <span class="hour-symbol ${isActive ? 'active' : ''}">${planet.symbol}</span>
                      <div class="hour-info">
                          <p class="hour-name">${ordinalHour(i + 1)} - ${planet.name}</p>
                          <p class="hour-slot">
                              <strong>UTC :</strong> ${formatTime(startTimeUTCInstance)} - ${formatTime(endTimeUTCInstance)}<br>
                              <strong>France :</strong> ${formatTime(startTimeLocal)} - ${formatTime(endTimeLocal)}
                          </p>
                      </div>
                  `;
                  cards.push(card);
              }
              return cards;
          }
  
          // Animation des transitions avec les nouvelles cartes
          animateTransition(dayContainer, () => createHourCards(sunrise, dayHourDuration, 0));
          animateTransition(nightContainer, () => createHourCards(sunset, nightHourDuration, 12));
  
      } catch (error) {
          console.error("Erreur lors de la récupération des données solaires :", error);
      }
  }

    async function fetchLocationName(lat, lng) {
      try {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
        const response = await fetch(url, { headers: { 'User-Agent': 'HeuresPlanétaires/1.0' } });
        const data = await response.json();
        return data.address.city || data.address.town || data.address.village || data.display_name || "Inconnue";
      } catch (error) {
        console.error("Erreur lors du reverse geocoding :", error);
        return "Inconnue";
      }
    }
    function updateLocationDisplay(newText) {
      const display = document.getElementById('location-display');
      const oldText = display.textContent;
      display.innerHTML = '';
      for (let i = 0; i < oldText.length; i++) {
        const span = document.createElement('span');
        span.textContent = oldText[i];
        display.appendChild(span);
        setTimeout(() => {
          span.classList.add('fade-letter-out');
        }, i * 50);
      }
      const totalDelay = oldText.length * 50 + 500;
      setTimeout(() => {
        display.innerHTML = '';
        for (let i = 0; i < newText.length; i++) {
          const span = document.createElement('span');
          span.textContent = newText[i];
          span.style.opacity = 0;
          display.appendChild(span);
          setTimeout(() => {
            span.classList.add('fade-letter-in');
          }, i * 50);
        }
      }, totalDelay);
    }
    async function geolocateUser() {
      const geoButton = document.getElementById('geolocate-button');
      const iconContainer = geoButton.querySelector('.icon-container');
      geoButton.disabled = true;
      iconContainer.classList.add('loading');
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async position => {
            currentLat = position.coords.latitude;
            currentLng = position.coords.longitude;
            const locationName = await fetchLocationName(currentLat, currentLng);
            const newLocationText = `Localisation : ${locationName} (${currentLat.toFixed(4)}, ${currentLng.toFixed(4)})`;
            updateLocationDisplay(newLocationText);
            const dateInput = document.getElementById('date-input');
            updatePlanetaryHours(dateInput.value);
            geoButton.disabled = false;
            iconContainer.classList.remove('loading');
          },
          error => {
            console.error("Erreur de géolocalisation :", error);
            geoButton.disabled = false;
            iconContainer.classList.remove('loading');
          }
        );
      } else {
        console.error("La géolocalisation n'est pas supportée par ce navigateur.");
        geoButton.disabled = false;
        iconContainer.classList.remove('loading');
      }
    }
    document.addEventListener("DOMContentLoaded", function() {
      const dateInput = document.getElementById('date-input');
      const today = new Date().toISOString().split("T")[0];
      dateInput.value = today;
      updatePlanetaryHours(today);
      dateInput.addEventListener('change', e => updatePlanetaryHours(e.target.value));
      document.getElementById('geolocate-button').addEventListener('click', geolocateUser);
    });